import { ColumnType } from "antd/es/table"
import { IProjectDataSQP } from "../types/projectDataSQP.types"
import useSearchColumn from "../../../hooks/useSearchColumn"
import useBaseColumns from "./UseBaseColumns"

const useProjectDataColumns = (keywordsCount: number): ColumnType<IProjectDataSQP>[] => {
  const searchColumnKeywordText = useSearchColumn<IProjectDataSQP>({ dataIndex: "searchTerm" })
  const columns = useBaseColumns()

  const columnsWithSearchQuery = [
    columns[0],
    {
      title: `Search Query (${keywordsCount})`,
      key: "searchTerm",
      dataIndex: "searchTerm",
      width: 400,
      ...searchColumnKeywordText,
    },
    ...columns.slice(1),
  ]

  return columnsWithSearchQuery
}

export default useProjectDataColumns
